export const SECTION_NAME = 'MB Banner';
export const COMPONENT_NAME = 'MB Ratings & Reviews';
